// @ts-nocheck
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useGetUserReportFileQuery} from '../../../../../../api'
import {useListView} from '../../core/ListViewProvider'
import {UsersListFilter} from './UsersListFilter'
import React, {useState, useCallback} from 'react'
import {BASE_URL} from '../../../../../../api'
import * as XLSX from 'xlsx'
import moment from 'moment'
import axios from 'axios'
import {useSelector} from 'react-redux'

const downloadExcel = (data) => {
  if (!data || data.length === 0) {
    alert('No data available to export')
    return
  }

  console.log('Exporting filtered bookings data:', {
    totalRecords: data.length,
    data: data,
  })

  // Transform data to match the actual table columns shown in the image
  const transformedData = data.map((booking) => {
    // BOOKING ID
    const booking_id = booking._id || 'N/A'

    // EMAIL
    const email = booking.user?.email || booking.email || 'N/A'

    // RESERVATIONS NAME
    const reservations_name = booking.reservationName || booking.name || 'N/A'

    // PERSONS
    const persons = booking.persons || booking.numberOfPeople || 1

    // TOTAL COST
    const total_cost = booking.total || booking.transaction.amount || 'N/A'

    // STRIPE ID
    const stripe_id = booking.transaction.stripeId || 'N/A'

    // DATE
    const date = booking.createdAt ? moment(new Date(booking.createdAt)).format('lll') : 'N/A'

    return {
      'BOOKING ID': booking_id,
      EMAIL: email,
      'RESERVATIONS NAME': reservations_name,
      PERSONS: persons,
      'TOTAL COST': total_cost,
      'STRIPE ID': stripe_id,
      DATE: date,
    }
  })

  console.log('Transformed bookings data for export:', transformedData)

  const worksheet = XLSX.utils.json_to_sheet(transformedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Bookings')

  // Add filename with filter info and timestamp
  const fileName = `BookingsData_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`
  XLSX.writeFile(workbook, fileName)
}

const UsersListToolbar = ({
  page,
  setPage,
  sDate,
  setSDate,
  setEDate,
  eDate,
  genderFilter,
  setGenderFilter,
  loading,
  setLoading,
  applyFilter,
  setApplyFilter,
  bookingsData,
}) => {
  const {setItemIdForUpdate} = useListView()
  const [exportLoading, setExportLoading] = useState(false)

  // Get current filter state from Redux
  const bookingsFilter = useSelector((state) => state.filter.bookingsFilter)

  const openAddUserModal = useCallback(() => {
    setItemIdForUpdate(null)
  }, [setItemIdForUpdate])

  const handleExport = useCallback(async () => {
    if (loading) {
      alert('Please wait for data to load before exporting')
      return
    }

    try {
      setExportLoading(true)
      console.log('Starting export of all filtered bookings data...')

      // Make API call to get ALL filtered data (not just current page)
      const response = await axios.get(`${BASE_URL}/admin/bookings`, {
        params: {
          page: 1, // Start from page 1
          limit: 10000, // Set a very high limit to get all data
          query: bookingsFilter.search || '',
          startDate: bookingsFilter.startDate || sDate || '',
          endDate: bookingsFilter.endDate || eDate || '',
          // Remove pagination to get all results
          export: true, // Add flag to indicate this is for export
        },
      })

      const {docs} = response.data
      console.log('Export API response - Total filtered records:', docs.length)

      if (!docs || docs.length === 0) {
        alert('No data found matching the current filters')
        return
      }

      // Export all filtered data
      downloadExcel(docs)
    } catch (error) {
      console.error('Error during export:', error)
      alert('Error occurred while exporting data. Please try again.')
    } finally {
      setExportLoading(false)
    }
  }, [loading, bookingsFilter, sDate, eDate])

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <UsersListFilter
        genderFilter={genderFilter}
        setGenderFilter={setGenderFilter}
        sDate={sDate}
        setSDate={setSDate}
        setEDate={setEDate}
        eDate={eDate}
        page={page}
        setPage={setPage}
        loading={loading}
        setLoading={setLoading}
        applyFilter={applyFilter}
        setApplyFilter={setApplyFilter}
      />

      {/* begin::Export Options */}
      <div className='d-flex flex-column me-3'>
        {/* Filter Info Message */}
        {/* {bookingsData && bookingsData.length > 0 && (
          <div className='text-muted fs-7 mb-2 text-center'>
            📊 Current page: {bookingsData.length} bookings
            {sDate && eDate && (
              <span className='ms-2'>
                • Date: {moment(sDate).format('MMM DD')} - {moment(eDate).format('MMM DD, YYYY')}
              </span>
            )}
            <div className='text-info mt-1'>
              ⚠️ Export will include ALL filtered data across all pages
            </div>
          </div>
        )} */}

        {/* Export Button */}
        <button
          type='button'
          className='btn btn-light-primary'
          onClick={handleExport}
          disabled={loading || exportLoading}
          title='Export ALL filtered booking records to Excel (across all pages)'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
          <span>{exportLoading ? 'Exporting...' : 'Export All'}</span>
        </button>
      </div>
      {/* end::Export Options */}

      {/* begin::Add user */}
      {/* <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add User
      </button> */}
      {/* end::Add user */}
    </div>
  )
}

export {UsersListToolbar}
